import React, { createContext, useContext, useState } from "react";

type SidebarContextType = {
  isSideRes: boolean;
  setIsSideRes: (value: boolean) => void;
};

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSideRes, setIsSideRes] = useState(false);

  return (
    <SidebarContext.Provider value={{ isSideRes, setIsSideRes }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) throw new Error("useSidebarContext must be used within SidebarProvider");
  return context;
};
